(function () {
    let ytReady = false, ytLoading = false, ytWaiters = [];
    function loadYT(cb) {
        if (ytReady) return cb();
        ytWaiters.push(cb);
        if (ytLoading) return;
        ytLoading = true;
        const s = document.createElement('script');
        s.src = 'https://www.youtube.com/iframe_api';
        document.head.appendChild(s);
        window.onYouTubeIframeAPIReady = () => {
            ytReady = true; ytWaiters.forEach(f => f()); ytWaiters = [];
        };
    }

    function getYouTubeId(input) {
        if (!input) return null;
        if (/<iframe/i.test(input)) {
            const m = input.match(/src=["']([^"']+)/i);
            if (m) input = m[1];
        }
        const m = input.match(/(?:youtu\.be\/|[?&]v=|\/embed\/|\/shorts\/)([A-Za-z0-9_-]{6,})/);
        return m ? m[1] : null;
    }

    function toBool(v, fallback = false) {
        if (v == null) return fallback;
        return v !== 'false' && v !== '0' && v !== 'no';
    }

    function initVideoThumbs(scope = document) {
        scope.querySelectorAll('.VideoPlayer--thumb').forEach(root => {
            // ✅ prevent double-init
            if (root.dataset.vpInit === '1') return;
            root.dataset.vpInit = '1';

            const type      = (root.dataset.type || '').toLowerCase();
            const src       = root.dataset.src || '';
            const posterURL = root.dataset.poster || '';

            let stage = root.querySelector('.VideoPlayer__stage');
            if (!stage) {
                stage = document.createElement('div');
                stage.className = 'VideoPlayer__stage';
                root.prepend(stage);
            }

            let posterEl = stage.querySelector('.VideoPlayer__poster');
            if (!posterEl) {
                posterEl = document.createElement('img');
                posterEl.className = 'VideoPlayer__poster';
                stage.appendChild(posterEl);
            }
            if (posterURL) posterEl.src = posterURL;

            function clearBackend() {
                stage.querySelectorAll('video, iframe, .VideoPlayer__holder').forEach(el => el.remove());
            }

            function bootLocal() {
                clearBackend();

                const autoplay    = toBool(root.dataset.autoplay, false);
                const muted       = toBool(root.dataset.muted, false);
                const controls    = toBool(root.dataset.controls, false);
                const playsinline = toBool(root.dataset.playsinline, true);
                const loop        = toBool(root.dataset.loop, false);

                const v = document.createElement('video');
                v.src = src;
                v.preload = 'metadata';
                v.playsInline = true;
                if (playsinline) v.setAttribute('playsinline', '');

                v.muted = muted || autoplay;
                if (v.muted) v.setAttribute('muted', '');

                v.autoplay = autoplay;
                if (autoplay) v.setAttribute('autoplay', '');

                v.controls = controls;

                v.loop = loop;
                if (loop) v.setAttribute('loop', '');

                stage.appendChild(v);

                if (autoplay) {
                    const tryPlay = () => v.play().catch(() => {});
                    v.addEventListener('loadedmetadata', tryPlay, { once: true });
                    if (v.readyState >= 1) tryPlay();
                }

                v.addEventListener('play', () => {
                    root.classList.add('is-started', 'is-playing');
                });
                v.addEventListener('pause', () => root.classList.remove('is-playing'));
                v.addEventListener('ended', () => { if (!loop) root.classList.remove('is-playing'); });
            }

            function bootYouTube() {
                const id = getYouTubeId(src);
                if (!id) return;

                const loop = toBool(root.dataset.loop, false);

                loadYT(() => {
                    clearBackend();

                    const holder = document.createElement('div');
                    holder.className = 'VideoPlayer__holder';
                    holder.style.cssText = 'position:absolute;inset:0;';
                    stage.appendChild(holder);

                    const playerVars = {
                        controls: 0,
                        rel: 0,
                        modestbranding: 1,
                        playsinline: 1,
                        loop: loop ? 1 : 0
                    };
                    if (loop) playerVars.playlist = id;

                    const player = new YT.Player(holder, {
                        videoId: id,
                        playerVars,
                        events: {
                            onStateChange: (e) => {
                                const P = YT.PlayerState;
                                if (e.data === P.PLAYING) root.classList.add('is-started', 'is-playing');
                                else if (e.data === P.PAUSED) root.classList.remove('is-playing');
                                else if (e.data === P.ENDED) { if (!loop) root.classList.remove('is-playing'); }
                                else if (e.data === P.UNSTARTED || e.data === P.BUFFERING) root.classList.remove('is-playing');
                            }
                        }
                    });

                    // ✅ bind click once
                    if (root.dataset.vpClickBound !== '1') {
                        root.dataset.vpClickBound = '1';
                        root.addEventListener('click', (e) => {
                            if (e.target.closest('button,a')) return;
                            const P = YT.PlayerState;
                            const s = player.getPlayerState?.();
                            if (!root.classList.contains('is-started')) root.classList.add('is-started');
                            (s === P.PLAYING) ? player.pauseVideo() : player.playVideo();
                        });
                    }
                });
            }

            if (type === 'file') bootLocal();
            else if (type === 'youtube') bootYouTube();
        });
    }

    // ✅ expose globally so infinite scroll can call it
    window.LUCDEN_initVideoThumbs = initVideoThumbs;

    // initial run
    document.addEventListener('DOMContentLoaded', () => initVideoThumbs(document));
})();